import { render, staticRenderFns } from "./CommonContent.vue?vue&type=template&id=6e37199a&"
import script from "./CommonContent.vue?vue&type=script&lang=js&"
export * from "./CommonContent.vue?vue&type=script&lang=js&"
import style0 from "./CommonContent.vue?vue&type=style&index=0&lang=less&scopeds=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports